import { render, staticRenderFns } from "./Politicadeprivacidade.vue?vue&type=template&id=d41f861e&"
import script from "./Politicadeprivacidade.vue?vue&type=script&lang=js&"
export * from "./Politicadeprivacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports